/**
 * Copyright (C) 2019 Olivier Parisot - All Rights Reserved.
 */

module.exports = 
{ 
	title: "forunr.com/2020",
	gaKey: 'UA-107413180-1',
	tileUrl: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
	flat: false,
	rootUrl:"https://www.doopyon.org/forunr/" 
}
  
